import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from 'base/shared/Localization';

import HeaderLang from 'components/header-lang';
import Footer from 'components/Layout/Footer';

import HomeActions from 'datamodel/Home/actions';
// import RoomCollections from 'app/components/RoomCollections/RoomCollections';

import { LINKED_CARDS, META_DATA, SEO_LINKS } from './constants';

import RoomSwitcher from 'app/v2/pages/Home/components/Switch';
import AllRooms from 'app/v2/pages/Home/components/AllRooms';
import Featured from 'app/v2/pages/Home/components/Featured';
import AnimatedSection from './components/animated-section';
import SeoLinks from './components/seo-links';

const Home = ({ location, openLogin }) => {
  const [showDistribution, setShowDistribution] = useState(true);
  const [activeOption, setActiveOption] = useState('all-rooms');

  const dispatch = useDispatch();
  const badiPlusCollection = useSelector((state) => state.Home?.badiPlusCollection);
  const token = useSelector((state) => state.Auth?.access_token);

  LINKED_CARDS.resources[0].clickHandler = openLogin;

  const handleOptionChange = (option) => {
    setActiveOption(option);
  };

  useEffect(() => {
    if (token) {
      dispatch(HomeActions.getBadiPlusCollection({ token }));
    }
  }, [dispatch, token]);

  return (
    <>
      <RoomSwitcher
        activeOption={activeOption}
        onOptionChange={handleOptionChange}
        defaultOption="all-rooms"
      />
      {activeOption === 'all-rooms' ? <AllRooms location={location} /> : <Featured />}

      <AnimatedSection>
        <SeoLinks {...SEO_LINKS} key="seo-links" />
      </AnimatedSection>
      <Helmet meta={translate(META_DATA.meta, 'content')} title={translate(META_DATA.title)} />
      <HeaderLang canonicalUrl={location?.pathname} relativePath={location?.pathname} />
      <Footer campaign="home_footer" />
    </>
  );
};

Home.defaultProps = {
  countryCode: null,
  location: {},
};

export default withRouter(Home);
